import { KTCard } from '../../../../_metronic/helpers'
import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React from 'react'
import { useAuth } from '../../auth'

const Menu = () => {
  const { currentUser } = useAuth()
  const { isSupplyChainManager } = useAuth()
  // const features = [
  //   { name: 'Suppliers', icon: 'waste collector', to: 'waste-collector' },
  //   ...((isSupplyChainManager && [{ name: 'Payables', icon: 'payments', to: 'payments' }]) || []),
  //   { name: 'Supply Ledger', icon: 'newsl', to: 'supply-ledger' },
  // ]
  const features = [
    {
      name: 'Plastic Keepers', icon: 'FTS Plastic Keeper', to: 'waste-collector'
    },
    ...((isSupplyChainManager && [{ name: 'Payables', icon: 'FST Payables', to: 'payments' }]) || []),
    // ...((currentUser as any)?.userType !== 'CLIENT' && [{ name: 'Plastic keeper Ledger', icon: 'newsl', to: 'supply-ledger' }] || []),
    ...((currentUser as any)?.userType !== 'CLIENT' && (currentUser as any)?.userType !== 'CLIENT_USER' && (currentUser as any)?.userType !== 'MARKETING' && [{ name: 'Plastic Keepers ledger', icon: 'FTS Plastic Keeper Ledger', to: 'supply-ledger' }] || []),
  ]
  return (
    <KTCard addCard={false}>
      <div className='row g-xl-4'>
        {features.map((eachFeatures, eachIndex) => (
          <div key={eachIndex + 1 + ''} className='col col-lg-2'>
            <Link className={clsx('menu-link without-sub')} to={eachFeatures.to}>
              <Card4
                // icon={`/media/svg/files/${eachFeatures.icon}.png`}
                icon={`/media/svg/files/${eachFeatures.icon}.png`}
                title={eachFeatures.name}
                description=''
              />
            </Link>
          </div>
        ))}
      </div>
    </KTCard>
  )
}

const WasteCollectorMenu = () => <Menu />

export { WasteCollectorMenu }
